import { render, staticRenderFns } from "./SplitterContextHelper.vue?vue&type=template&id=10740835&"
import script from "./SplitterContextHelper.vue?vue&type=script&lang=js&"
export * from "./SplitterContextHelper.vue?vue&type=script&lang=js&"
import style0 from "./SplitterContextHelper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports